export default __webpack_public_path__ + "static/media/69.46609579.png";